import config from "config/config.js";

const signup = body => {
  const endpoint = `${config.baseUrl}/api/authentication/sign-up`;
  const options = {
    method: "post",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": `*`,
      "Access-Control-Allow-Credentials": false,
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    credentials: "include",
    body: JSON.stringify(body)
  };
  return fetch(endpoint, options)
    .then(response => response.json())
    .then(res => {
      if (res.error && res.error.status) {
        if (res.error.status === 401) {
          console.log("error 401");
          return null;
        } else {
          console.log("generic error");
          return res.error.status;
        }
      }
      window.location.href = config.clientUrl;
      return res;
    })
    .catch(e => {
      // eslint-disable-next-line no-console
      console.log("errore", e);
    });
};

export default signup;
